import * as yup from "yup";

const coversPath = (field: string, path: string) =>
  path === field || path.startsWith(`${field}[`) || path.startsWith(`${field}.`);

export function areFieldsValid(
  schema: yup.AnyObjectSchema,
  values: unknown,
  fields: readonly string[],
): boolean {
  try {
    schema.validateSync(values, { abortEarly: false });
    return true;
  } catch (error) {
    if (!(error instanceof yup.ValidationError)) throw error;
    return !error.inner.some(({ path = "" }) => fields.some((field) => coversPath(field, path)));
  }
}
